import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import SearchResult from "./SearchResult";
import Snackbar from "@material-ui/core/Snackbar";
import { discussionClient } from "../../AxiosClient";
import axios from "../../AxiosClient";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Skeleton from "@material-ui/lab/Skeleton";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Pagination from "@material-ui/lab/Pagination";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import SearchResultDiscussion from "./SearchResultDiscussion";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import CloseIcon from "@material-ui/icons/Close";
import CardHeader from "@material-ui/core/CardHeader";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Link } from "react-router-dom";
import PropertyNames from "../../PropertyNames";
import { getSearchLanguages } from "../../utils/KpsUtils";
import Filter from "../filter/Filter";
import { currentUserHasRole, Role } from "../../utils/RoleUtils";
import axiosImport from "axios";
import Media from "react-media";

const drawerWidth = 400;

const styles = (theme) => ({
  pageContainer: {
    height: "100%",
  },
  resultsContainer: {
    overflow: "auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
    marginTop: 5,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    marginTop: 5,
  },
  score: {
    marginLeft: "auto",
  },
  card: {
    height: "100%",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    //marginLeft: 5,
    borderRadius: 4,
    boxShadow:
      "0px 1px 3px 0px rgba(0,0,0,0.5), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(6) + 1,
    "& > #filterCard": {
      display: "none",
    },
    //marginLeft: 5,
    borderRadius: 4,
    boxShadow:
      "0px 1px 3px 0px rgba(0,0,0,0.5), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingTop: 0,
    // height: "100%",
  },
  contentMobile: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingTop: 0,
    // height: "100%",
  },
  contentWrapper: {
    border: "1px solid rgb(195,195,195)",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  expansionPanel: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
  },
  addToList: {
    padding: 0,
    marginLeft: 10,
  },
  green: {
    color: theme.palette.success.main,
  },
  paginationCard: {
    display: "flex",
    justifyContent: "center",
    // marginTop: "auto",
    marginBottom: 10,
    marginTop: 10,
  },
  skeletonCard: {
    borderBottom: "1px solid rgb(222,222,222)",
  },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class SearchPage extends Component {
  defaultFilters = {
    liveDraftMode: "Live",
    languages: ["en"],
    anyWordExact: [],
    allWordExact: [],
    exactPhrase: [],
    noWordExact: [],
    languages: getSearchLanguages(
      this.props.currentUser,
      this.props.appProperties
    ),
  };
  state = {
    results: [],
    searchString: "",
    filtersOpen: false,
    menuAnchor: null,
    userLists: [],
    searchId: "",
    snackbarOpen: false,
    newListSnackbarOpen: false,
    pageSize: 10,
    startIndex: 0,
    pageSizeDiscussion: 10,
    startPageDiscussion: 1,
    totalDiscussions: 0,
    bottomScrolled: false,
    awaitingResults: true,
    page: 1,
    totalItems: 0,
    discussionOpen: false,
    discussionResults: [],
    settingsAnchorEl: null,
    defaultFilters: { ...this.defaultFilters },
    filters: {
      ...this.defaultFilters,
    },
    gettingDiscussions: false,
    error: false,
  };

  cancelToken = null;
  searchString = "";

  componentDidUpdate(prevProps, prevState) {
    // if (!areObjectsEqual(this.state.filters, prevState.filters)) {
    //   this.props.setSearchStats && this.props.setSearchStats(0, 0);
    //   this.setState(
    //     {
    //       pageSize: this.state.filters.pageSize
    //         ? this.state.filters.pageSize
    //         : 10,
    //       startIndex: 0,
    //       page: 1,
    //     },
    //     () => {
    //       this.getResults();
    //     }
    //   );
    //   // this.getDocuments();
    // }
    if (this.searchString !== this.props.match.params.str) {
      this.props.setSearchStats && this.props.setSearchStats(0, 0);
      this.searchString = this.props.match.params.str;

      this.setState(
        {
          pageSize: this.state.filters.pageSize
            ? this.state.filters.pageSize
            : 10,
          startIndex: 0,
          page: 1,
        },
        () => {
          this.getResults();
        }
      );
    }
    if (this.state.page !== prevState.page) {
      this.props.setSearchStats && this.props.setSearchStats(0, 0);
      this.getDocuments();
    }
    if (this.state.pageSize !== prevState.pageSize) {
      this.props.setSearchStats && this.props.setSearchStats(0, 0);
      this.getDocuments();
    }
  }

  onFilterChange = (filters) => {
    this.props.setSearchStats && this.props.setSearchStats(0, 0);
    this.setState(
      {
        pageSize: this.state.filters.pageSize
          ? this.state.filters.pageSize
          : 10,
        startIndex: 0,
        page: 1,
        filters,
      },
      () => {
        this.getResults();
      }
    );
  };

  componentDidMount() {
    this.searchString = this.props.match.params.str;

    // this.getResults();
    this.getUserLists();
  }

  toggleFilterDrawer = () => {
    this.setState((prev) => ({ filtersOpen: !prev.filtersOpen }));
  };

  handlePageChange = () => {};

  render() {
    const { classes, t } = this.props;
    return (
      <div className={classes.pageContainer}>
        <main
          className={classNames((this.props.isMobile && this.props.isMobile) === true ? classes.contentMobile : classes.content, {
            [classes.contentShift]: this.state.filtersOpen,
          })}
        >
          <Drawer
            className={classNames(classes.drawer, {
              [classes.drawerOpen]: this.state.discussionOpen,
              [classes.drawerClose]: !this.state.discussionOpen,
            })}
            classes={{
              paper: classNames({
                [classes.drawerOpen]: this.state.discussionOpen,
                [classes.drawerClose]: !this.state.discussionOpen,
              }),
            }}
            // className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={this.state.discussionOpen}
          >
            <CardHeader
              title={<div>Discussions</div>}
              action={
                <>
                  <IconButton
                    onClick={() =>
                      this.setState({
                        discussionOpen: !this.state.discussionOpen,
                      })
                    }
                  >
                    <CloseIcon />
                  </IconButton>
                </>
              }
            />
            <List
              style={{
                height: "100%",
                overflowY: "auto",
                paddingLeft: 16,
                paddingTop: 16,
                paddingBottom: 24,
              }}
            >
              {/* {this.state.discussionOpen && this.state.discussionResults.map((discussion) =>
                <SearchResultDiscussion discussion={discussion} />
              )} */}

              {this.state.gettingDiscussions ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    height: "100%",
                  }}
                >
                  <div style={{ display: "flex", width: "100%" }} />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", height: "100%" }} />
                    <CircularProgress
                      size={100}
                      className="add-choice-dialog-spinner"
                    />
                    <div style={{ display: "flex", height: "100%" }} />
                  </div>
                  <div style={{ display: "flex", width: "100%" }} />
                </div>
              ) : (
                this.state.discussionOpen &&
                this.state.discussionResults.map((discussion) => (
                  <SearchResultDiscussion discussion={discussion} />
                ))
              )}
            </List>
            <Pagination
              style={{ margin: 8, alignSelf: "center" }}
              count={this.state.totalDiscussions}
              page={this.state.startPageDiscussion}
              onChange={this.getDiscussions}
              color="primary"
              rowsPerPage={10}
            />
          </Drawer>

          <div style={{ display: "block", width: "100%" }}>
            <Filter
              filterType="search"
              defaultFilters={this.state.defaultFilters}
              onChange={this.onFilterChange}
            />
          </div>
          {this.state.awaitingResults ? (
            <>
              {Array.from(Array(10)).map(() => {
                return (
                  <Card square className={classes.skeletonCard}>
                    <div
                      style={{
                        marginTop: 4,
                        marginBottom: 8,
                        display: "flex",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Skeleton
                          variant="rect"
                          style={{
                            width: "50%",
                            marginTop: 5,
                            marginLeft: 10,
                          }}
                          height={31}
                          animation="wave"
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Skeleton
                          variant="rect"
                          style={{ width: "80%", marginTop: 5 }}
                          height={31}
                          animation="wave"
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Skeleton
                          variant="rect"
                          style={{
                            width: "25%",
                            marginTop: 5,
                            float: "right",
                            marginRight: 10,
                          }}
                          height={31}
                          animation="wave"
                        />
                      </div>
                    </div>
                  </Card>
                );
              })}
            </>
          ) : (
            <>
              {this.state.error ? (
                <>
                  <Card style={{ padding: 20, textAlign: "center" }}>
                    <Typography>
                      An error occurred while searching.{" "}
                      <Link onClick={() => this.getResults()}>
                        Click here to try again.
                      </Link>
                    </Typography>
                  </Card>
                </>
              ) : (
                <>
                  {this.state.results.length === 0 ? (
                    <>
                      <Card style={{ padding: 20, textAlign: "center" }}>
                        <Typography>
                          No results found for search:{" "}
                          {this.searchString}
                        </Typography>
                        <Link
                          to={{
                            pathname: "/full/createexpertquestion",
                            state: {
                              title: this.searchString,
                            },
                          }}
                        >
                          <Typography>
                            {t("search_no_results_create_expert_question")}
                          </Typography>
                        </Link>
                      </Card>
                    </>
                  ) : (
                    <Paper
                      square
                      elevation={3}
                      id="results-container"
                      className={classes.resultsContainer}
                    >
                      {this.state.results.map((result, idx) => {
                        let resolution = this.state.previousResolutions.filter(
                          (item) => item.documentId === result.documentId
                        );
                        return (
                          <SearchResult
                            mobile={this.props.isMobile}
                            urlDocId={this.props.match.params.docid}
                            secondaryInfo={this.props.secondaryInfo}
                            createNewUserList={this.createNewUserList}
                            key={idx}
                            result={result}
                            userLists={this.state.userLists}
                            searchId={result.searchId}
                            addResultToList={this.addResultToList}
                            position={idx + 1}
                            score={result.score}
                            onResolution={this.props.onResolution}
                            onUnResolved={this.props.onUnResolved}
                            resolutions={this.props.resolutions}
                            previouslyResolved={resolution.length > 0}
                            lastResolvedDate={
                              resolution.length > 0
                                ? resolution[0].lastUsed
                                : null
                            }
                          />
                        );
                      })}
                    </Paper>
                  )}
                </>
              )}
            </>
          )}
          <Card className={classes.paginationCard}>
            {/* {!this.state.discussionOpen && */}
            <IconButton
              aria-label="Show discussion results"
              onClick={() => {
                this.setState({ discussionOpen: true });
              }}
            >
              <QuestionAnswerIcon />
            </IconButton>
            {/* } */}
            <div style={{ display: "flex", flex: 1, marginTop: 8 }}>
              <div style={{ flex: 1 }}>
                <Typography
                  style={{
                    display: "inline-block",
                    marginRight: 10,
                    marginTop: 4,
                  }}
                  id="search-results-per-page-label"
                >
                  {this.props.t("search_results_per_page")}
                </Typography>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="search-results-per-page-label"
                    id="search-results-per-page"
                    value={this.state.pageSize}
                    onChange={(e) =>
                      this.setState({ pageSize: e.target.value })
                    }
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <Pagination
                count={Math.ceil(this.state.totalItems / this.state.pageSize)}
                page={this.state.page}
                onChange={(_e, v) => {
                  this.setState({ page: v });
                }}
                color="primary"
              />

              {this.searchString && currentUserHasRole(Role.ASK_EXPERT) ? (
                <Link
                  style={{
                    flex: 1,
                    textAlign: "right",
                    alignSelf: "center",
                    paddingRight: 15,
                  }}
                  to={{
                    pathname: "/full/createexpertquestion",
                    state: {
                      title: this.searchString,
                    },
                  }}
                >
                  <Typography>
                    {t("search_footer_create_expert_question")}
                  </Typography>
                </Link>
              ) : (
                <div style={{ visibility: "hidden", flex: 1 }} />
              )}
            </div>
          </Card>
        </main>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          autoHideDuration={6000}
          open={this.state.snackbarOpen}
          onClose={this.handleSnackbarClose}
          message={t("document_added_snackbar")}
        />

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          autoHideDuration={6000}
          open={this.state.newListSnackbarOpen}
          onClose={this.handleNewUserListSnackbarClose}
          message={t("list_created_and_document_added_snackbar")}
        />
      </div>
    );
  }

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  handleNewUserListSnackbarClose = () => {
    this.setState({ newListSnackbarOpen: false });
  };

  addResultToList = (list, result) => {
    let existingItems = JSON.parse(list.items);
    existingItems.push({
      type: "document",
      id: result.documentId,
    });
    axios
      .patch(`/userlist/${list.id}`, {
        items: JSON.stringify(existingItems),
        id: list.id,
      })
      .then(() => {
        this.getUserLists();
        this.setState({ snackbarOpen: true });
      });
  };

  createNewUserList = (result, title) => {
    let itemsList = [{ type: "document", id: result.documentId }];
    axios
      .post("/userlist/", {
        items: JSON.stringify(itemsList),
        title,
      })
      .then((res) => {
        this.setState({
          newListSnackbarOpen: true,
          userLists: [...this.state.userLists, res.data],
        });
      });
  };

  getUserLists = () => {
    axios.post("/userlist/list/", { withCredentials: true }).then((res) => {
      this.setState({ userLists: res.data.content });
    });
  };

  prepareTaxonomyNodes = (taxonomyFilter) => {
    //Create a list of TaxonomySelections (taxonomies or communities)

    let taxonomies = taxonomyFilter.filter((ele) => ele.type === "taxonomy");
    //get all the topic nodes and filter out an duplicates
    let topics = taxonomyFilter
      .filter((ele) => ele.type === "topic")
      .filter((ele, i, arr) => arr.indexOf(ele) === i);
    topics = topics
      .filter(
        (topic) =>
          taxonomies.map((ele) => ele.id).indexOf(topic.object.taxonomyId) ===
          -1
      )
      .map((ele) => {
        return { id: ele.object[ele.type + "Id"], type: ele.type };
      });
    //no process the taxonomies and put the nodes highest up the list into a filtered list
    let filteredTaxonomies = [];
    let sorted = taxonomies.sort((a, b) => {
      return a.parentList.length > b.parentList.length
        ? 1
        : a.parentList.length < b.parentList.length
          ? -1
          : 0;
    });
    sorted.forEach(
      (tax) =>
        taxonomies
          .map((ele) => ele.id)
          .indexOf(tax.parentList[tax.parentList.length - 1]) === -1 &&
        filteredTaxonomies.push(tax)
    );
    return topics.concat(
      filteredTaxonomies.map((ele) => {
        return { id: ele.id, type: ele.type };
      })
    );
  };
  getDiscussions = (e, v) => {
    e && this.setState({ startPageDiscussion: v, gettingDiscussions: true });
    discussionClient
      .post("/discussion/search/", {
        searchText: this.searchString,
        startPage: e ? v : this.state.startPageDiscussion,
        pageSize: this.state.pageSizeDiscussion,
        //   params: {
        //     startPage: this.state.startPageDiscussion,
        //     pageSize: this.state.pageSizeDiscussion,
        //   },
        //   pagable: {
        //     startPage: this.state.startPageDiscussion,
        //     pageSize: this.state.pageSizeDiscussion,
        //   }
        // }, {
        //   startPage: this.state.startPageDiscussion,
        //   pageSize: this.state.pageSizeDiscussion,
        // }
      })
      .then((res) => {
        this.setState({
          discussionResults: res.data.content,
          totalDiscussions: res.data.totalPages,
          gettingDiscussions: false,
        });
      });
  };

  getDocuments = () => {
    if (this.cancelToken && this.cancelToken.cancel) {
      // cancel inflight data request
      this.cancelToken.cancel();
    }
    this.cancelToken = axiosImport.CancelToken.source();
    this.setState({ awaitingResults: true });
    let myfilters = Object.assign({}, this.state.filters);
    if (this.state.filters.hasOwnProperty("taxonomy") === true) {
      myfilters.taxonomy = this.prepareTaxonomyNodes(myfilters.taxonomy);
    }
    axios
      .post(
        "/search/",
        {
          ...myfilters,
          searchString: this.searchString,
          startPage: this.state.page,
          pageSize: this.state.pageSize,
        },
        { cancelToken: this.cancelToken.token }
      )
      .then((res) => {
        this.setState({
          awaitingResults: false,
          error: false,
          searchId: res.data.searchId,
          previousResolutions: res.data.previousResolutions,
        });
        this.props.setPreviousResolutions &&
          this.props.setPreviousResolutions(res.data.previousResolutions);
        this.setState({
          results: res.data.page.content,
          totalItems: res.data.page.totalElements,
        });
        this.props.setSearchStats &&
          this.props.setSearchStats(
            res.data.page.totalElements,
            res.data.timeTaken
          );
        this.props.setSearchId && this.props.setSearchId(res.data.searchId);
      })
      .catch((err) => {
        if (axiosImport.isCancel(err)) return;
        this.setState({ error: true, awaitingResults: false });
      });
  };

  getResults = () => {
    this.getDiscussions();
    this.getDocuments();
  };
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  appProperties: state.setting.applicationProperties,
  isMobile: state.screen.isMobile,
});
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withRouter(withTranslation()(SearchPage))));
